import { eventAnniversary } from './anniversary';
import { eventBonus } from './bonus';
import { eventBrewfest } from './brewfest';
import { eventDarkmoonFaire } from './darkmoon-faire';
import { eventHallowsEnd } from './hallows-end';
import { eventNoblegarden } from './noblegarden';
import { eventTimewalking } from './timewalking';

export const eventTasks = [
    eventAnniversary,
    eventBonus,
    eventBrewfest,
    eventDarkmoonFaire,
    eventHallowsEnd,
    eventNoblegarden,
    eventTimewalking,
];
